import React from 'react';
import { KFLButton } from '@kamstrup/kamstrup-frontend-library';
import { AppKeys } from '../../core/localization';
import Translate from '../shared/localization/localize';
import { submitForm } from '../../utils';
import { Groups, GroupNames } from '../../models';

interface OwnProps {
  group: Groups;
  fnSearch: any;
  fnClear: any;
  isLoading: boolean;
}

type Props = OwnProps;

const SidebarForm: React.FC<Props> = (props) => {
  const prefix = `sidebar-${GroupNames[props.group]}`;

  return (
    <div id={prefix} className={prefix} onKeyDown={submitForm(props.fnSearch)}>
      {props.children}
      <span className="inputSeparator">&nbsp;</span>
      <div className="btn_group_left">
        <KFLButton
          id={`${prefix}_btn_search`}
          onClick={props.fnSearch}
          disabled={props.isLoading}
        >
          <Translate message={AppKeys.Btn_Search} />
        </KFLButton>
        <KFLButton
          id={`${prefix}_btn_clear`}
          variant="borderless"
          onClick={props.fnClear}
        >
          <Translate message={AppKeys.Btn_Clear} />
        </KFLButton>
      </div>
    </div>
  );
};

export default SidebarForm;
